// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iEVQ","controls":"styles_controls__jL9Pe","charLimit":"styles_charLimit__-e1Og","input":"styles_input__36EvO","send":"styles_send__3J7MS"};